// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"374":"600039ed1d97475c","432":"b3e643809db240a8","538":"650a6047b2c90040","983":"031e1bbce82c3adf"}[chunkId] + ".js";
};